/** @format */

import {
  useContext,
  useEffect,
  useState,
} from 'react';

import {
  Route,
  Routes,
} from 'react-router';

import ChangeForgotPassword from '../Components/Auth/ChangeForgotPassword';
import ForgotPassword from '../Components/Auth/ForgotPassword';
import Login from '../Components/Auth/Login';
import Register from '../Components/Auth/Register';
import SetPassword from '../Components/Auth/SetPassword';
import { EventRegister } from '../Components/EventRegister';
import {
  Event,
  Events,
  Home,
} from '../Components/Home';
import SelectGender from '../Components/Home/SelectGender';
import { PaymentTracking } from '../Components/Payment';
import { Show } from '../Components/User';
import {
  IDCard,
  ShowIDCard,
} from '../Components/UserIDCard';
import { EventContext } from '../Contexts/EventContext';
import Error404 from '../Shared/Components/Errors/Error404';
import Loading from '../Shared/Components/Loading';
import { error } from '../Shared/Components/Toast';
import useApi from '../Shared/hooks/api/Index';
import { checkLogin } from '../Shared/hooks/authenticate';

const RestrictedRoutes = () => {
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await useApi.get(
        'setting',
        {},
        (res) => {
          eventContext.setting = res.data.data;
        },
        () => {
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );

      if (checkLogin()) {
        await useApi.get(
          'auth/me',
          {},
          (res) => {
            eventContext.authUser = res.data.data;
            eventContext.authRoles = res.data.data?.roles ?? [];
          },
          () => {
            error('هنگام دریافت اطلاعات خطایی رخ داده است');
          },
        );
      }

      setLoading(false);
    };
    init();
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <Routes>
      <Route exact path='/event/register/:id' element={<EventRegister />} />
      <Route exact path='/event/show/:id/gender' element={<SelectGender />} />
      <Route exact path='/event/show/:id' element={<Event />} />
      <Route exact path='/event/:category' element={<Events />} />
      <Route exact path='/payment/tracking' element={<PaymentTracking />} />
      <Route exact path='/id-card' element={<IDCard />} />
      <Route exact path='/id-card/show' element={<ShowIDCard />} />
      <Route
        exact
        path='/id-card/event/:eventId/user/:userId'
        element={<Show />}
      />
      <Route exact path='/' element={<Home />} />
      <Route exact path='/login' element={<Login />} />
      <Route exact path='/register' element={<Register />} />
      <Route exact path='/register/password' element={<SetPassword />} />
      <Route exact path='/forgot/password' element={<ForgotPassword />} />
      <Route
        exact
        path='/forgot/password/change'
        element={<ChangeForgotPassword />}
      />
      <Route path='*' element={<Error404 />} />
    </Routes>
  );
};

export default RestrictedRoutes;
